import Api from '@/api/api'


export default {
    getDevices(data) {
     
        // return Api.get(`/api/Device/GetAllDevicesForSuperAdmin`);
    return Api.get(`/api/Device/GetAllDevicesForSuperAdmin?PageNo=${data.PageNo}&PageSize=${data.pageSize}&SearchQuery=${data.searchQuery}`);

    },
    deviceAuditLog(data){
        return Api.get(`/api/Device/GetIMEIActivityForSuperAdmin?IMEI=${data}`);

    },
    exportTemplate(data) {
        return Api.get(`/api/Device/GetAllDevicesForSuperAdminExport?SearchQuery=${data}`, {
            responseType: 'blob',
        });
    },
    getInitialData() {
        return Api.get(`/api/InitialData/GetSuperAdminInitialData`);
    },
    getDeviceById(deviceId) {
        return Api.get(`/api/Device/GetDeviceByID/${deviceId}`);
    },
    updateDevice(editId, deviceData) {
        return Api.put(`/api/Device/UpdateDeviceByAdmin/${editId}`, deviceData);
    },
    deleteDevice(deviceId) {
        // return Api.delete(`/api/Device/DeleteDevice/${id}`);
        // console.log('[ deleteDevice API is under Consturction ] Params Passed => ', deviceId);
        return Api.delete(`/api/Device/DeleteDeviceByAdmin/${deviceId}`);
    },
    addDevice(data) {
        return Api.post(`/api/Device/AddDeviceByAdmin?tenantId=${data.tenantId}`, data);
    },
    downloadTemplate() {
        return Api.get('/api/Device/DownloadTemplate', {
            responseType: 'blob',
        });
    },
    uploadTemplate(formData, config) {
        return Api.post(`/api/Device/UploadTemplate`, formData, config);
    },
}

